
// import React, { useState, useEffect } from 'react';
// import '../styles/CompanyPolicy.css';
// import logoWhite from '../assets/logowhite.png';
// import careerPathwaysImg from '../assets/careerpathways.png';
// import competencyMatrixImg from '../assets/careerpathways2.png';
// import { useLocation } from "react-router-dom";




// const CompanyPolicy = ({ userData }) => {
//   const location = useLocation();
//   const selectedFromDashboard = location.state?.selectedPathway;
//   const [selectedPolicy, setSelectedPolicy] = useState(null);
//   const [companyLogo, setCompanyLogo] = useState("");

//   const isGenesis =
//     userData?.EmailId
//       ?.toLowerCase()
//       ?.includes("genesistech.co.in");

//   const [dynamicPathways, setDynamicPathways] =
//     useState([]);


//   const [logs, setLogs] = useState({});
//   const [loading, setLoading] = useState(false);




//   useEffect(() => {
//     if (selectedFromDashboard) {
//       const found = pathways.find(
//         p => p.title === selectedFromDashboard
//       );

//       if (found) {
//         setSelectedPolicy(found);
//       }
//     }
//   }, [selectedFromDashboard]);

//   useEffect(() => {

//     const email =
//       userData?.EmailId || "";

//     const domain =
//       email.split("@")[1];

//     if (!domain) return;

//     fetch(
//       "/gt-api/get_company_logo.php",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           domain
//         })
//       }
//     )
//       .then(res => res.json())
//       .then(data => {

//         if (
//           data.success &&
//           data.company_logo
//         ) {

//           setCompanyLogo(
//             `/gt-api/${data.company_logo}`
//           );

//         }

//       })
//       .catch(console.error);

//   }, [userData]);

//   const empBadgeId = userData?.EmpId || userData?.employeeId;
//   const fullName = `${userData?.FirstName || ''} ${userData?.LastName || ''}`.trim();
//   const API_URL = "/gt-api/acknowledgepolicy.php";

//   // Define table styles here
//   const thStyle = {
//     border: "1px solid #ddd",
//     padding: "10px",
//     textAlign: "left",
//     fontWeight: "600",
//   };

//   const tdStyle = {
//     border: "1px solid #ddd",
//     padding: "10px",
//     verticalAlign: "top",
//   };

//   useEffect(() => {
//     const fetchMyLogs = async () => {
//       if (!empBadgeId) return;
//       try {
//         const response = await fetch(`${API_URL}?empId=${empBadgeId}`);
//         const data = await response.json();
//         const signedMap = data.reduce((acc, curr) => {
//           acc[curr.policy_title] = true;
//           return acc;
//         }, {});
//         setLogs(signedMap);
//       } catch (e) {
//         console.error("Failed to load policy signatures:", e);
//       }
//     };
//     fetchMyLogs();
//   }, [empBadgeId]);

//   useEffect(() => {

//     if (isGenesis) return;

//     fetch(
//       "/gt-api/get_career_pathways.php",
//       {
//         credentials: "include"
//       }
//     )
//       .then(res => res.json())
//       .then(data => {

//         if (data.success) {
//           setDynamicPathways(
//             data.pathways || []
//           );
//         }

//       })
//       .catch(console.error);

//   }, [isGenesis]);

//   const handleReadStatus = async (policyTitle) => {
//     if (!empBadgeId) {
//       alert("User Session Missing: EmpId not found. Please log out and back in.");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await fetch(API_URL, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           empId: empBadgeId,
//           fullName: fullName,
//           policyTitle: policyTitle
//         }),
//       });
//       const result = await response.json();
//       if (result.status === "success") {
//         setLogs(prev => ({ ...prev, [policyTitle]: true }));
//       } else {
//         alert("Server Error: " + (result.message || "Could not save."));
//       }
//     } catch (error) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const isRead = (title) => logs[title] || false;




//   const genesisPathways = [
//     {
//       id: 1,
//       title: "FI DESIGN",
//       icon: "📊",
//       content: (


//         <div className="policy-details-text">

//           <h2>FI Design Growth Metrics & Role Progression Framework</h2>

//           <p>
//             This document presents a detailed and structured Career Progression Framework
//             for FI Design team aimed at enabling clarity, motivation, and long-term
//             growth for every team member. The progression is based on years of service,
//             technical competency, leadership skills, performance excellence, and
//             contributions to project success.
//           </p>

//           <p>
//             The purpose of this framework is to empower every BIM professional with a
//             clear understanding of expectations, development pathways, and opportunities
//             available within the organization.
//           </p>


//           <section>
//             <strong>1. Role Progression Overview</strong>

//             <p>
//               The table below defines eligibility for roles based on minimum years of
//               service, expectations, and demonstrated capabilities.
//             </p>

//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 marginTop: "10px"
//               }}
//             >
//               <thead>
//                 <tr >
//                   <th style={thStyle}>Eligible at Service Year</th>
//                   <th style={thStyle}>Eligible Role</th>
//                   <th style={thStyle}>Role Description</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 <tr>
//                   <td style={tdStyle}>0 Years</td>
//                   <td style={tdStyle}>
//                     Structural Engineer<br />
//                     Mechanical Engineer<br />
//                     Electrical Engineer
//                   </td>
//                   <td style={tdStyle}>
//                     Entry level role. Ability to contribute to basic team deliverables.
//                     Gets trained on scope of work and becomes proficient in outputting
//                     work on schedule with high quality.
//                   </td>
//                 </tr>

//                 <tr>
//                   <td style={tdStyle}>2 Years</td>
//                   <td style={tdStyle}>
//                     Sr. Structural Engineer<br />
//                     Sr. Mechanical Engineer<br />
//                     Sr. Electrical Engineer
//                   </td>
//                   <td style={tdStyle}>
//                     Assisting new hires, solving junior issues, handling complex technical
//                     challenges. Ability to apply logic and critical thinking to solve
//                     complex problems and identify automation opportunities.
//                   </td>
//                 </tr>

//                 <tr>
//                   <td style={tdStyle}>4 Years</td>
//                   <td style={tdStyle}>
//                     Team Lead (Structural / Mechanical / Electrical)
//                   </td>
//                   <td style={tdStyle}>
//                     Leads the work group, resolves technical questions, assigns work,
//                     manages workload, ensures proper training plans and documentation
//                     exist for team continuity.
//                   </td>
//                 </tr>

//                 <tr>
//                   <td style={tdStyle}>6 Years</td>
//                   <td style={tdStyle}>Engineering Manager</td>
//                   <td style={tdStyle}>
//                     Manages the overall team, monitors team performance, coordinates
//                     customer feedback, sets quarterly directives, and builds a
//                     high-performing team across disciplines.
//                   </td>
//                 </tr>

//                 <tr>
//                   <td style={tdStyle}>9 Years</td>
//                   <td style={tdStyle}>Sr. Engineering Manager</td>
//                   <td style={tdStyle}>
//                     Oversees managers in the same business unit, sets strategic team
//                     direction, interacts with customers, and implements feedback into
//                     operational workflows.
//                   </td>
//                 </tr>
//               </tbody>
//             </table>


//             <div style={{ marginTop: "30px", textAlign: "center" }}>
//               <img
//                 src={careerPathwaysImg}
//                 alt="Role Progression Chart"
//                 style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
//               />
//             </div>
//           </section>

//           <section>
//             <strong>2. Growth Metrics and Expectations</strong>
//             <p>
//               Each step in the career pathway requires meeting specific measurable expectations. These metrics ensure fairness, transparency, and accountability.
//             </p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Technical mastery and continuous learning across discipline-specific and cross-discipline content.</li>
//               <li>Ability to understand, follow, and implement design BKM processes and consider the impact of other disciplines.</li>
//               <li>High quality and accurate design packages and deliverables with minimal supervision.</li>
//               <li>Proactive collaboration with team members, consultants, and clients.</li>
//               <li>Strong problem-solving skills and willingness to explore optimization methods.</li>
//               <li>Leadership qualities including initiative, mentoring, and ownership of responsibilities.</li>
//               <li>Adherence to deadlines and ability to perform efficiently under pressure.</li>
//               <li>Adaptability to learn and use new methods or standards when systems are upgraded.</li>
//               <li>Initiative to identify issues and implement potential solutions.</li>
//             </ul>
//           </section>


//           <section>
//             <strong>3. Promotion Eligibility Criteria</strong>

//             <p><strong>Discipline Engineer to Sr. Discipline Engineer (After 2 Years)</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Ability to understand the full training content.</li>
//               <li>Application of delivered training into day-to-day job</li>
//               <li>Critically think and be able to navigate through the technical challenges in the best possible way.</li>
//               <li>Communicate issues with engineers in timely manner and proactively work towards providing solutions to those issues.</li>
//               <li>Understand the core scope of works and always strive to have positive customer feedback.</li>
//               <li>Ensuring no deadlines are missed.</li>
//               <li>Being involved in hiring process ensuring correct candidate fitting the team and meeting job requirement is hired.</li>
//             </ul>

//             <p><strong>Sr. Discipline Engineer to Team Lead (After 4 Years)</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Help train junior members of the team.</li>
//               <li>Ensure that the new team members are up to speed and at contributing phase towards the team post training by performing their work independently.</li>
//               <li>Answer issues of new folks in timely manner.</li>
//               <li>Ability to highlight bottlenecks and work with manager towards resolving it.</li>
//               <li>Ability to highlight high value time consuming repetitive tasks and recommend manager proposal to automate them.</li>
//               <li>Being involved in hiring process ensuring correct candidate fitting the team and meeting job requirement is hired.</li>
//             </ul>

//             <p><strong>Team Lead to Engineering Manager (After 6 Years)</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Being a responsible, highly organized individual.</li>
//               <li>Manage work assignment and manage workload.</li>
//               <li>Ensure all training documents, videos are properly arranged and easily accessible to the team members.</li>
//               <li>Deal with complex engineering questions and help team resolve them in efficient way.</li>
//               <li>Ability to manage time with team lead responsibilities and regular day to day activities.</li>
//               <li>Being involved in hiring process ensuring correct candidate fitting the team and meeting job requirement is hired.</li>
//             </ul>

//             <p><strong>Engineering Manager to Sr. Engineering Manager (After 9 Years)</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Manage the team with high efficiency</li>
//               <li>Oversee team functioning, manage employee 1:1 and ability to handle issues raised by the employee.</li>
//               <li>Continuously thinking about team improvements and recommend suggestions to your manager.</li>
//               <li>Work on feedback provided by employee and provide regular feedback to the employee.</li>
//               <li>Identify critical metrics and build team indicators showing the operations of the team.</li>
//               <li>Be part of annual performance review sessions and ensure conducting fair annual review process.</li>
//               <li>Be a path finder for the team. Work on new scopes highly complex items and set up scope of work process flow for the team.</li>
//               <li>Demonstrator of great values, innovator, receptive to fast changes and able to manage team in fast changing environments.</li>
//               <li>Being involved in hiring process ensuring correct candidate fitting the team and meeting job requirement is hired.</li>
//             </ul>
//           </section>

//           <section>
//             <strong>4. Additional Guidelines</strong>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Years of service indicate minimum eligibility, not automatic promotion. Performance and competency are mandatory requirements.</li>
//               <li>Even though highly rare, employees may be promoted earlier if they demonstrate exceptional skills, leadership, and impact. This is completely decision of your manager and management. No employee must make the request on their own.</li>
//               <li>Training new folks, self-training and contribution to innovation increases promotion readiness.</li>
//               <li>Leadership roles require demonstration of ownership, communication ability, and team support.</li>
//               <li>Promotions are reviewed annually or as per business needs.</li>
//             </ul>
//           </section>




//           <section>
//             <strong>Competency Matrix by Role</strong>
//             <p>
//               The competency matrix defines the expected proficiency level for each role across key competency areas. Proficiency levels are defined as:
//             </p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>L1 = Beginner (needs guidance)</li>
//               <li>L2 = Intermediate (works independently on routine tasks)</li>
//               <li>L3 = Advanced (handles complexity, mentors others)</li>
//               <li>L4 = Expert (sets standards, leads strategy)</li>
//               <li><strong>Note:</strong> L0 indicates not expected at that level.</li>
//             </ul>


//             <div style={{ textAlign: "center", margin: "20px 0" }}>
//               <img
//                 src={competencyMatrixImg}
//                 alt="Competency Matrix Table"
//                 style={{ maxWidth: "100%", height: "auto", border: "1px solid #ccc", borderRadius: "8px" }}
//               />
//             </div>
//           </section>


//           <section>
//             <strong>6. Competency Areas</strong>

//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>
//                 <strong>Engineering Designs:</strong> Discipline specific designs in accordance with the design and drafting standard.
//               </li>
//               <li>
//                 <strong>Data Validations:</strong> Effectively highlight gaps in the supplier data leading to non-designable content and delaying the start of the designs.
//               </li>
//               <li>
//                 <strong>Design & Drafting Standards:</strong> Understand and implement all code requirements and follow CAD drafting standards ensuring quality design packages.
//               </li>
//               <li>
//                 <strong>Documentation & QA/QC:</strong> Creating project drawings/documents and checking them for quality, accuracy, and mistakes.
//               </li>
//               <li>
//                 <strong>Coordination with other disciplines/Scopes:</strong> Working with all other teams or different scopes in the team to make sure we are following the standard and coordinating.
//               </li>
//               <li>
//                 <strong>Innovation and Automation:</strong> Ability to simplify process and execute quality work at fast pace by implementing automation.
//               </li>
//               <li>
//                 <strong>Communication & Stakeholder Management:</strong> Talking clearly with team members, clients, consultants, and managing their expectations professionally.
//               </li>
//               <li>
//                 <strong>Planning & Estimation:</strong> Manage all projects in assigned timeline ensuring proper work timelines to complete the assigned tasks.
//               </li>
//               <li>
//                 <strong>Leadership & Mentoring:</strong> Guiding team members, helping them learn, assigning tasks, and supporting teamwork.
//               </li>
//               <li>
//                 <strong>Process Improvement & Innovation:</strong> Finding better, faster ways to do work, improving workflows, introducing new ideas or tools.
//               </li>
//             </ul>
//           </section>

//         </div>
//       )
//     },
//     {
//       id: 2,
//       title: "BIM MODELING",
//       icon: "🏗️",
//       content: (
//         <div className="policy-details-text">
//           <h2>BIM Team Growth Metrics & Role Progression Framework</h2>

//           <p>
//             This document presents a detailed and structured BIM Career Progression Framework aimed at enabling clarity, motivation, and long-term growth for every team member. The progression is based on a blend of years of service, technical competency, leadership skills, performance excellence, and contributions to project success. The purpose of this framework is to empower every BIM professional with a clear understanding of expectations, development pathways, and opportunities available within the organization.
//           </p>

//           <section>
//             <strong>1. Role Progression Overview</strong>
//             <p>The table below defines eligibility for roles based on minimum years of service, standard expectations, and capability demonstration:</p>
//             <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
//               <thead>
//                 <tr>
//                   <th style={thStyle}>Eligible at Service Year</th>
//                   <th style={thStyle}>Eligible Role</th>
//                   <th style={thStyle}>Role Description</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td style={tdStyle}>0 Years</td>
//                   <td style={tdStyle}>BIM Modeler</td>
//                   <td style={tdStyle}>Entry-level role focused on model creation, documentation, and learning BIM standards.</td>
//                 </tr>
//                 <tr>
//                   <td style={tdStyle}>2 Years</td>
//                   <td style={tdStyle}>Senior BIM Modeler</td>
//                   <td style={tdStyle}>Advanced modeling responsibilities, quality checks, and mentoring junior modelers.</td>
//                 </tr>
//                 <tr>
//                   <td style={tdStyle}>2 Years</td>
//                   <td style={tdStyle}>BIM Lead (Eligibility)</td>
//                   <td style={tdStyle}>Acts as the go-to technical expert Eligible for technical leadership roles based on performance and expertise.</td>
//                 </tr>
//                 <tr>
//                   <td style={tdStyle}>4 Years</td>
//                   <td style={tdStyle}>BIM Coordinator / BIM Engineer</td>
//                   <td style={tdStyle}>Manages model coordination, clash detection, workflow optimization, and works closely with project leads and engineering teams.</td>
//                 </tr>
//                 <tr>
//                   <td style={tdStyle}>6 Years</td>
//                   <td style={tdStyle}>BIM Manager</td>
//                   <td style={tdStyle}>Oversee BIM processes, standards, team development, project strategy, and implementation. Enforces standards and ensures team development and drives innovation.</td>
//                 </tr>
//                 <tr>
//                   <td style={tdStyle}>9 Years</td>
//                   <td style={tdStyle}>Senior BIM Manager</td>
//                   <td style={tdStyle}>Leads the BIM function across multiple projects or a region. They set standards, strategy, and quality, mentor BIM teams, and work with project leadership and clients to ensure BIM delivers time, cost, and quality outcomes.</td>
//                 </tr>
//               </tbody>
//             </table>

//             <div style={{ marginTop: "30px", textAlign: "center" }}>
//               <img
//                 src={require('../assets/careerpathways3.png')}
//                 alt="BIM Role Progression Chart"
//                 style={{ maxWidth: "80%", height: "460px", borderRadius: "8px" }}
//               />
//             </div>
//           </section>

//           <section>
//             <strong>2. Growth Metrics & Expectations</strong>
//             <p>Each step in the BIM career pathway requires meeting specific measurable expectations. These metrics ensure fairness, transparency, and accountability.</p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Technical mastery and continuous learning across BIM platforms (Revit, Navisworks, BIM 360, Dynamo, etc.).</li>
//               <li>Ability to understand, follow, and implement internal BIM guidelines and standards.</li>
//               <li>Quality and accuracy of models, drawings, and deliverables with minimal supervision.</li>
//               <li>Proactive collaboration with team members, consultants, and clients.</li>
//               <li>Problem-solving ability and willingness to explore optimization methods.</li>
//               <li>Leadership qualities such as initiative, mentoring, and ownership of responsibilities.</li>
//               <li>Adherence to deadlines and ability to work efficiently under pressure.</li>
//               <li>Being flexible and able to learn and use new methods or standards when the company changes or upgrades its systems.</li>
//             </ul>
//           </section>

//           <section>
//             <strong>3. Promotion Eligibility Criteria</strong>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.8", marginBottom: "20px" }}>
//               <li style={{ marginBottom: "10px" }}>
//                 BIM Modeler → Senior BIM Modeler (After 2 Years)
//                 <ol style={{ marginTop: "10px", paddingLeft: "20px", lineHeight: "1.6" }}>
//                   <li>High proficiency in Revit, BIM360/ACC, Navisworks, and other BIM tools.</li>
//                   <li>Consistently delivers high-quality models with minimal errors.</li>
//                   <li>Shows initiative in supporting team tasks and improving workflows.</li>
//                   <li>Good understanding of project requirements and scope.</li>
//                   <li>Ability to mentor newly joined modelers and assist leads.</li>
//                 </ol>
//               </li>

//               <li style={{ marginBottom: "10px" }}>
//                 Senior BIM Modeler → BIM Coordinator / BIM Engineer (After 4 Years)
//                 <ol style={{ marginTop: "10px", paddingLeft: "20px", lineHeight: "1.6" }}>
//                   <li>Leads discipline-level modeling tasks and ensures model integrity.</li>
//                   <li>Efficiently handles clash detection workflows and resolves coordination issues.</li>
//                   <li>Experience working with multi-disciplinary teams and understanding cross-discipline impacts.</li>
//                   <li>Strong communication skills for issue tracking, reporting, and meetings.</li>
//                   <li>Demonstrates readiness to take ownership of project coordination responsibilities.</li>
//                 </ol>
//               </li>

//               <li style={{ marginBottom: "10px" }}>
//                 BIM Coordinator / BIM Engineer → BIM Manager (After 6 Years)
//                 <ol style={{ marginTop: "10px", paddingLeft: "20px", lineHeight: "1.6" }}>
//                   <li>Leads entire BIM strategy and project delivery from a management standpoint.</li>
//                   <li>Experience in creating BIM Execution Plans, workflows, and enforcing standards.</li>
//                   <li>Capable of managing multiple teams.</li>
//                   <li>Capable of managing multiple projects or disciplines simultaneously.</li>
//                   <li>Provides training, guidance, and strategic direction for the BIM team.</li>
//                   <li>Drives automation, innovation, and digital adoption across processes.</li>
//                 </ol>
//               </li>
//             </ul>
//           </section>

//           <section>
//             <strong>4. Additional Guidelines</strong>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Years of service indicate minimum eligibility, not automatic promotion. Performance and competency are mandatory requirements.</li>
//               <li>Employees may be promoted earlier if they demonstrate exceptional skills, leadership, and impact.</li>
//               <li>Training new folks, self-training and contribution to innovation increase promotion readiness.</li>
//               <li>Leadership roles (such as BIM Lead) require demonstration of ownership, communication ability, and team support.</li>
//               <li>Promotions are reviewed annually or as per business needs.</li>
//             </ul>
//           </section>

//           <section>
//             <strong>5. Competency Matrix by Role</strong>
//             <p>The competency matrix defines the expected proficiency level for each role across key competency areas. Proficiency levels are defined as:</p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>L1 = Beginner (needs guidance)</li>
//               <li>L2 = Intermediate (works independently on routine tasks)</li>
//               <li>L3 = Advanced (handles complexity, mentors others)</li>
//               <li>L4 = Expert (sets standards, leads strategy)</li>

//               <li> Note : L0 indicates not expected at that level.</li>
//             </ul>

//           </section>


//           <div style={{ textAlign: "center", margin: "20px 0" }}>
//             <img
//               src={require('../assets/careerpathways4.png')}
//               alt="Competency Matrix Visual Aid"
//               style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", border: "1px solid #ccc" }}
//             />
//           </div>

//           <li>
//             <strong>1. Revit Modelling & Families:</strong> Making building models in Revit and creating basic components like doors, windows, furniture, etc.
//           </li>
//           <li>
//             <strong>2. Navisworks / Clash Detection:</strong> Using Navisworks to combine all discipline models (Arch/Str/MEP) and find clashes (where elements collide) before project delivery.
//           </li>
//           <li>
//             <strong>3. BIM Standards:</strong> Following the rules and guidelines for how BIM models, files, naming, and workflows should be created and managed in a project.
//           </li>
//           <li>
//             <strong>4. Documentation & QA/QC:</strong> Creating project drawings/documents and checking them for quality, accuracy, and mistakes.
//           </li>
//           <li>
//             <strong>5. Coordination with Other Disciplines:</strong> Working with all other teams or different scope in the team to make sure we are following the standard and coordinating.
//           </li>
//           <li>
//             <strong>6. Automation (Dynamo / Scripts):</strong> Using tools like Dynamo or scripts to automate repetitive tasks in Revit or other BIM tools to save time.
//           </li>
//           <li>
//             <strong>7. CDE Platforms (BIM 360 / ACC):</strong> Using cloud platforms like BIM 360 or ACC to store, manage, track, and share project files so everyone works with the latest information.
//           </li>
//           <li>
//             <strong>8. Communication & Stakeholder Handling:</strong> Talking clearly with team members, clients, consultants, and managing their expectations professionally.
//           </li>
//           <li>
//             <strong>9. Planning & Estimation (LOD, timelines):</strong> Understanding Level of Development (LOD) and planning how detailed the model should be and how long tasks will take.
//           </li>
//           <li>
//             <strong>10. Leadership & Mentoring:</strong> Guiding team members, helping them learn, assigning tasks, and supporting teamwork.
//           </li>
//           <li>
//             <strong>11. Process Improvement & Innovation:</strong> Finding better, faster ways to do work, improving workflows, introducing new ideas or tools.
//           </li>


//         </div>
//       )
//     },

//     {
//       id: 3,
//       title: "POWER BI",
//       icon: "📈",
//       content: (
//         <div className="policy-details-text">

//           <h2>Technical Project Coordinator (Power BI)</h2>

//           <p><strong>Team Growth Metrics & Role Progression Framework</strong></p>

//           <p>
//             This document outlines a structured career progression pathway for Technical Project Coordinators specializing in Power BI and data analytics solutions. The objective is to provide transparency in career development, motivate continuous learning, and define clear expectations for team members as they grow within the organization.
//           </p>

//           <p>
//             The progression is based on a combination of technical expertise, analytical thinking, project coordination capability, business understanding, leadership qualities, and performance excellence.
//           </p>

//           <p>This framework helps every team member understand:</p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//             <li>What skills they must develop</li>
//             <li>What responsibilities they must demonstrate</li>
//             <li>How they can grow long-term within the organization</li>
//           </ul>

//           <section>
//             <strong>1. Role Progression Overview</strong>

//             <p>The table below defines eligibility for roles based on minimum years of service, standard expectations, and capability demonstration:</p>

//             <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
//               <thead>
//                 <tr>
//                   <th style={thStyle}>Eligible at Service Year</th>
//                   <th style={thStyle}>Eligible Role</th>
//                   <th style={thStyle}>Role Description</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 <tr>
//                   <td style={tdStyle}>0 Years</td>
//                   <td style={tdStyle}>Power BI Analyst / Junior Technical Coordinator</td>
//                   <td style={tdStyle}>Entry-level role focused on building dashboards, cleaning data, assisting with reporting tasks, and learning internal data standards and tools.</td>
//                 </tr>

//                 <tr>
//                   <td style={tdStyle}>2 Years</td>
//                   <td style={tdStyle}>Senior Power BI Analyst</td>
//                   <td style={tdStyle}>Responsible for advanced dashboard creation, data modelling, performance optimization, and assisting in data-driven decision making.</td>
//                 </tr>

//                 <tr>
//                   <td style={tdStyle}>3 Years</td>
//                   <td style={tdStyle}>Technical Project Coordinator (Power BI)</td>
//                   <td style={tdStyle}>Coordinates reporting requirements with stakeholders, manages reporting timelines, ensures data accuracy, and leads dashboard delivery for projects.</td>
//                 </tr>

//                 <tr>
//                   <td style={tdStyle}>5 Years</td>
//                   <td style={tdStyle}>Data Analytics Lead / BI Lead</td>
//                   <td style={tdStyle}>Leads analytics initiatives, manages reporting strategy, mentors analysts, and ensures dashboards align with business goals.</td>
//                 </tr>

//                 <tr>
//                   <td style={tdStyle}>7 Years</td>
//                   <td style={tdStyle}>Analytics Manager / BI Manager</td>
//                   <td style={tdStyle}>Oversees BI architecture, reporting standards, team growth, analytics strategy, and cross-department data initiatives.</td>
//                 </tr>

//                 <tr>
//                   <td style={tdStyle}>10 Years</td>
//                   <td style={tdStyle}>Head of Business Intelligence / Data Strategy Lead</td>
//                   <td style={tdStyle}>Drives enterprise analytics strategy, governs data standards, collaborates with leadership, and enables data-driven culture across the organization.</td>
//                 </tr>
//               </tbody>
//             </table>

//             <div style={{ marginTop: "30px", textAlign: "center" }}>
//               <img
//                 src={require('../assets/careerpathways5.png')}
//                 alt="Power BI Role Progression Chart"
//                 style={{ maxWidth: "80%", height: "460px", borderRadius: "8px" }}
//               />
//             </div>

//           </section>

//           <section>
//             <strong>2. Growth Metrics & Expectations</strong>

//             <p>Progression in the analytics team requires measurable contributions across the following areas:</p>

//             <p><strong>Technical Capability</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Strong knowledge of Power BI, DAX, Power Query, and data modelling</li>
//               <li>Understanding of SQL, databases, and data structures</li>
//               <li>Ability to create efficient, scalable dashboards and reports</li>
//               <li>Knowledge of data cleaning, transformation, and automation</li>
//             </ul>

//             <p><strong>Business Understanding</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Ability to translate business problems into data solutions</li>
//               <li>Understanding of KPIs, business metrics, and reporting needs</li>
//             </ul>

//             <p><strong>Project Coordination</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Managing reporting timelines</li>
//               <li>Ensuring stakeholders receive accurate and timely data</li>
//               <li>Coordinating with multiple departments</li>
//             </ul>

//             <p><strong>Communication</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Clear communication of insights</li>
//               <li>Ability to present dashboards and explain findings</li>
//             </ul>

//             <p><strong>Data Quality & Governance</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Maintaining data accuracy</li>
//               <li>Ensuring reporting standards and governance practices</li>
//             </ul>

//             <p><strong>Innovation & Automation</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Automating repetitive reporting tasks</li>
//               <li>Improving workflows through scripts or tools</li>
//             </ul>

//             <p><strong>Leadership & Mentorship</strong></p>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Helping junior team members</li>
//               <li>Guiding best practices</li>
//               <li>Supporting team collaboration</li>
//             </ul>
//           </section>

//           <section>
//             <strong>4. Additional Guidelines</strong>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>Years of service indicate minimum eligibility, not automatic promotion.</li>
//               <li>Promotions depend on performance, leadership, and impact.</li>
//               <li>Employees showing exceptional capability may be promoted earlier.</li>
//               <li>Contributing to automation, documentation, and innovation accelerates growth.</li>
//               <li>Promotion reviews occur annually or based on business requirements.</li>
//             </ul>
//           </section>

//           <section>
//             <strong>5. Competency Matrix by Role</strong>

//             <p>The competency matrix defines the expected proficiency level for each role across key competency areas. Proficiency levels are defined as:</p>

//             <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
//               <li>L1 = Beginner (needs guidance)</li>
//               <li>L2 = Intermediate (works independently on routine tasks)</li>
//               <li>L3 = Advanced (handles complexity, mentors others)</li>
//               <li>L4 = Expert (sets standards, leads strategy)</li>
//               <li> Note : L0 indicates not expected at that level.</li>
//             </ul>

//             {/* <div style={{ textAlign: "center", margin: "20px 0" }}>
//           <img
//             src={require('../assets/careerpathways4.png')}
//             alt="Competency Matrix Visual Aid"
//             style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", border: "1px solid #ccc" }}
//           />
//         </div> */}

//             <li><strong>1. Power BI Dashboard Development:</strong> Creating dashboards, reports, and visualizations to present data insights clearly.</li>
//             <li><strong>2. Data Modelling:</strong> Designing relationships between tables and structuring datasets efficiently.</li>
//             <li><strong>3. DAX Calculations:</strong> Creating advanced calculations and performance-optimized measures.</li>
//             <li><strong>4. Data Transformation (Power Query):</strong> Cleaning, transforming, and preparing data from multiple sources.</li>
//             <li><strong>5. SQL & Data Sources:</strong> Working with databases and integrating multiple data sources.</li>
//             <li><strong>6. Data Governance & Documentation:</strong> Maintaining documentation, version control, and reporting standards.</li>
//             <li><strong>7. Stakeholder Requirement Gathering:</strong> Understanding business needs and translating them into dashboards.</li>
//             <li><strong>8. Insight Generation & Storytelling:</strong> Communicating insights clearly to decision makers.</li>
//             <li><strong>9. Automation & Workflow Optimization:</strong> Using scripts, APIs, or automated refresh workflows.</li>
//             <li><strong>10. Project Coordination:</strong> Managing reporting timelines, deliverables, and stakeholder expectations.</li>
//             <li><strong>11. Leadership & Mentorship:</strong> Supporting team members, assigning work, and improving collaboration.</li>
//             <li><strong>12. Analytics Strategy & Innovation:</strong> Developing new analytics solutions and improving business intelligence processes.</li>

//           </section>

//         </div>
//       )
//     }

//   ];

//   const pathways = isGenesis
//     ? genesisPathways
//     : dynamicPathways.map(item => ({
//       id: item.id,
//       title: item.pathway_title,
//       icon: item.pathway_icon,
//       content: (
//         <div
//           style={{
//             whiteSpace: "pre-wrap",
//             lineHeight: "1.9"
//           }}
//           dangerouslySetInnerHTML={{
//             __html: item.pathway_content
//               .replace(/\n/g, "<br>")
//           }}
//         />
//       )
//     }));

 
//    return (
//   <div className="policy-wrapper">

//     {/* DESKTOP */}
//     <div className="desktop-career-layout">

//       <div className="policy-sidebar-nav glass">
//         <div className="sidebar-header"></div>
//         <div className="policy-menu">
//           {pathways.map((p) => (
//             <div
//               key={p.id}
//               className={`policy-item ${selectedPolicy?.id === p.id ? 'active' : ''}`}
//               onClick={() => setSelectedPolicy(p)}
//             >
//               <div className="active-indicator"></div>
//               <span className="p-icon">{p.icon}</span>
//               <span className="p-text">{p.title}</span>
//               {isRead(p.title) && <span className="p-status-check">✅</span>}
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="policy-viewer glass">
//         {selectedPolicy ? (
//           <div className="viewer-content animate-fade">
//             <div className="viewer-header">
//               <div className="header-info">
//                 <h1>{selectedPolicy.title}</h1>
//               </div>
//             </div>

//             <div className="cyber-divider"></div>

//             <div className="document-body">
//               <section className="doc-section">
//                 {selectedPolicy.content}
//               </section>

//               <div className="acknowledgement-section" style={{ marginTop: '40px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px', textAlign: 'center' }}>
//                 {/* acknowledgement button remains commented */}
//               </div>
//             </div>

//             <div className="policy-footer">
//               <p>
//                 © {isGenesis
//                   ? "Genesis Tech Engineers Pvt. Ltd."
//                   : "Career Pathways"}
//               </p>
//             </div>
//           </div>
//         ) : (
//           <div style={{ position: "relative", width: "100%", height: "100%" }}>
//             <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center" }}>
//               <img
//                 src={
//                   isGenesis
//                     ? logoWhite
//                     : (
//                       companyLogo ||
//                       logoWhite
//                     )
//                 }
//                 alt="Company Logo"
//                 style={{
//                   width: "350px",
//                   height: "auto",
//                   marginBottom: "80px"
//                 }}
//               />

//               <p
//                 style={{
//                   fontSize: "25px",
//                   opacity: "0.8",
//                   whiteSpace: "nowrap"
//                 }}
//               >
//                 PICK FROM THE SIDEBAR TO READ IT.
//               </p>
//             </div>
//           </div>
//         )}
//             </div>

//     </div>

//     {/* MOBILE */}
//     {!selectedPolicy ? (

//       <div className="mobile-career-list">

//         {pathways.map((p) => (

//           <div
//             key={p.id}
//             className="mobile-career-card"
//             onClick={() => setSelectedPolicy(p)}
//           >

//             <span className="mobile-career-icon">
//               {p.icon}
//             </span>

//             <span className="mobile-career-title">
//               {p.title}
//             </span>

//           </div>

//         ))}

//       </div>

//     ) : (

//       <div className="mobile-career-viewer">

//         <button
//           className="mobile-career-back"
//           onClick={() => setSelectedPolicy(null)}
//         >
//           ← Back
//         </button>

//         <div className="viewer-content animate-fade">

//           <div className="viewer-header">
//             <div className="header-info">
//               <h1>{selectedPolicy.title}</h1>
//             </div>
//           </div>

//           <div className="cyber-divider"></div>

//           <div className="document-body">
//             <section className="doc-section">
//               {selectedPolicy.content}
//             </section>
//           </div>

//         </div>

//       </div>

//     )}

//   </div>
// );
// };

// export default CompanyPolicy;

























import React, { useState, useEffect } from 'react';
import '../styles/CompanyPolicy.css';
import logoWhite from '../assets/logowhite.png';
import careerPathwaysImg from '../assets/careerpathways.png';
import competencyMatrixImg from '../assets/careerpathways2.png';
import { useLocation } from "react-router-dom";




const CompanyPolicy = ({ userData }) => {
  const location = useLocation();
  const selectedFromDashboard = location.state?.selectedPathway;
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [companyLogo, setCompanyLogo] = useState("");

  const isGenesis =
    userData?.EmailId?.toLowerCase()?.includes("genesistech.co.in") ||
    userData?.EmailId?.toLowerCase()?.includes("gtecorpgroup.com") ||
    userData?.EmailId?.toLowerCase()?.includes("gtcorpgroup.com");

  const [dynamicPathways, setDynamicPathways] =
    useState([]);


  const [logs, setLogs] = useState({});
  const [loading, setLoading] = useState(false);




  useEffect(() => {
    if (selectedFromDashboard) {
      const found = pathways.find(
        p => p.title === selectedFromDashboard
      );

      if (found) {
        setSelectedPolicy(found);
      }
    }
  }, [selectedFromDashboard]);

  useEffect(() => {

    const email =
      userData?.EmailId || "";

    const domain =
      email.split("@")[1];

    if (!domain) return;

    fetch(
      "/gt-api/get_company_logo.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          domain
        })
      }
    )
      .then(res => res.json())
      .then(data => {

        if (
          data.success &&
          data.company_logo
        ) {

          setCompanyLogo(
            `/gt-api/${data.company_logo}`
          );

        }

      })
      .catch(console.error);

  }, [userData]);

  const empBadgeId = userData?.EmpId || userData?.employeeId;
  const fullName = `${userData?.FirstName || ''} ${userData?.LastName || ''}`.trim();
  const API_URL = "/gt-api/acknowledgepolicy.php";

  // Define table styles here
  const thStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    textAlign: "left",
    fontWeight: "600",
  };

  const tdStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    verticalAlign: "top",
  };

  useEffect(() => {
    const fetchMyLogs = async () => {
      if (!empBadgeId) return;
      try {
        const response = await fetch(`${API_URL}?empId=${empBadgeId}`);
        const data = await response.json();
        const signedMap = data.reduce((acc, curr) => {
          acc[curr.policy_title] = true;
          return acc;
        }, {});
        setLogs(signedMap);
      } catch (e) {
        console.error("Failed to load policy signatures:", e);
      }
    };
    fetchMyLogs();
  }, [empBadgeId]);

  useEffect(() => {

    if (isGenesis) return;

    fetch(
      "/gt-api/get_career_pathways.php",
      {
        credentials: "include"
      }
    )
      .then(res => res.json())
      .then(data => {

        if (data.success) {
          setDynamicPathways(
            data.pathways || []
          );
        }

      })
      .catch(console.error);

  }, [isGenesis]);

  const handleReadStatus = async (policyTitle) => {
    if (!empBadgeId) {
      alert("User Session Missing: EmpId not found. Please log out and back in.");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empId: empBadgeId,
          fullName: fullName,
          policyTitle: policyTitle
        }),
      });
      const result = await response.json();
      if (result.status === "success") {
        setLogs(prev => ({ ...prev, [policyTitle]: true }));
      } else {
        alert("Server Error: " + (result.message || "Could not save."));
      }
    } catch (error) {
      alert("Failed to connect to the server.");
    } finally {
      setLoading(false);
    }
  };

  const isRead = (title) => logs[title] || false;




  const genesisPathways = [
    {
      id: 1,
      title: "FI DESIGN",
      icon: "📊",
      content: (


        <div className="policy-details-text">

          <h2>FI Design Growth Metrics & Role Progression Framework</h2>

          <p>
            This document presents a detailed and structured Career Progression Framework
            for FI Design team aimed at enabling clarity, motivation, and long-term
            growth for every team member. The progression is based on years of service,
            technical competency, leadership skills, performance excellence, and
            contributions to project success.
          </p>

          <p>
            The purpose of this framework is to empower every BIM professional with a
            clear understanding of expectations, development pathways, and opportunities
            available within the organization.
          </p>


          <section>
            <strong>1. Role Progression Overview</strong>

            <p>
              The table below defines eligibility for roles based on minimum years of
              service, expectations, and demonstrated capabilities.
            </p>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "10px"
              }}
            >
              <thead>
                <tr >
                  <th style={thStyle}>Eligible at Service Year</th>
                  <th style={thStyle}>Eligible Role</th>
                  <th style={thStyle}>Role Description</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style={tdStyle}>0 Years</td>
                  <td style={tdStyle}>
                    Structural Engineer<br />
                    Mechanical Engineer<br />
                    Electrical Engineer
                  </td>
                  <td style={tdStyle}>
                    Entry level role. Ability to contribute to basic team deliverables.
                    Gets trained on scope of work and becomes proficient in outputting
                    work on schedule with high quality.
                  </td>
                </tr>

                <tr>
                  <td style={tdStyle}>2 Years</td>
                  <td style={tdStyle}>
                    Sr. Structural Engineer<br />
                    Sr. Mechanical Engineer<br />
                    Sr. Electrical Engineer
                  </td>
                  <td style={tdStyle}>
                    Assisting new hires, solving junior issues, handling complex technical
                    challenges. Ability to apply logic and critical thinking to solve
                    complex problems and identify automation opportunities.
                  </td>
                </tr>

                <tr>
                  <td style={tdStyle}>4 Years</td>
                  <td style={tdStyle}>
                    Team Lead (Structural / Mechanical / Electrical)
                  </td>
                  <td style={tdStyle}>
                    Leads the work group, resolves technical questions, assigns work,
                    manages workload, ensures proper training plans and documentation
                    exist for team continuity.
                  </td>
                </tr>

                <tr>
                  <td style={tdStyle}>6 Years</td>
                  <td style={tdStyle}>Engineering Manager</td>
                  <td style={tdStyle}>
                    Manages the overall team, monitors team performance, coordinates
                    customer feedback, sets quarterly directives, and builds a
                    high-performing team across disciplines.
                  </td>
                </tr>

                <tr>
                  <td style={tdStyle}>9 Years</td>
                  <td style={tdStyle}>Sr. Engineering Manager</td>
                  <td style={tdStyle}>
                    Oversees managers in the same business unit, sets strategic team
                    direction, interacts with customers, and implements feedback into
                    operational workflows.
                  </td>
                </tr>
              </tbody>
            </table>


            <div style={{ marginTop: "30px", textAlign: "center" }}>
              <img
                src={careerPathwaysImg}
                alt="Role Progression Chart"
                style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
              />
            </div>
          </section>

          <section>
            <strong>2. Growth Metrics and Expectations</strong>
            <p>
              Each step in the career pathway requires meeting specific measurable expectations. These metrics ensure fairness, transparency, and accountability.
            </p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Technical mastery and continuous learning across discipline-specific and cross-discipline content.</li>
              <li>Ability to understand, follow, and implement design BKM processes and consider the impact of other disciplines.</li>
              <li>High quality and accurate design packages and deliverables with minimal supervision.</li>
              <li>Proactive collaboration with team members, consultants, and clients.</li>
              <li>Strong problem-solving skills and willingness to explore optimization methods.</li>
              <li>Leadership qualities including initiative, mentoring, and ownership of responsibilities.</li>
              <li>Adherence to deadlines and ability to perform efficiently under pressure.</li>
              <li>Adaptability to learn and use new methods or standards when systems are upgraded.</li>
              <li>Initiative to identify issues and implement potential solutions.</li>
            </ul>
          </section>


          <section>
            <strong>3. Promotion Eligibility Criteria</strong>

            <p><strong>Discipline Engineer to Sr. Discipline Engineer (After 2 Years)</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Ability to understand the full training content.</li>
              <li>Application of delivered training into day-to-day job</li>
              <li>Critically think and be able to navigate through the technical challenges in the best possible way.</li>
              <li>Communicate issues with engineers in timely manner and proactively work towards providing solutions to those issues.</li>
              <li>Understand the core scope of works and always strive to have positive customer feedback.</li>
              <li>Ensuring no deadlines are missed.</li>
              <li>Being involved in hiring process ensuring correct candidate fitting the team and meeting job requirement is hired.</li>
            </ul>

            <p><strong>Sr. Discipline Engineer to Team Lead (After 4 Years)</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Help train junior members of the team.</li>
              <li>Ensure that the new team members are up to speed and at contributing phase towards the team post training by performing their work independently.</li>
              <li>Answer issues of new folks in timely manner.</li>
              <li>Ability to highlight bottlenecks and work with manager towards resolving it.</li>
              <li>Ability to highlight high value time consuming repetitive tasks and recommend manager proposal to automate them.</li>
              <li>Being involved in hiring process ensuring correct candidate fitting the team and meeting job requirement is hired.</li>
            </ul>

            <p><strong>Team Lead to Engineering Manager (After 6 Years)</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Being a responsible, highly organized individual.</li>
              <li>Manage work assignment and manage workload.</li>
              <li>Ensure all training documents, videos are properly arranged and easily accessible to the team members.</li>
              <li>Deal with complex engineering questions and help team resolve them in efficient way.</li>
              <li>Ability to manage time with team lead responsibilities and regular day to day activities.</li>
              <li>Being involved in hiring process ensuring correct candidate fitting the team and meeting job requirement is hired.</li>
            </ul>

            <p><strong>Engineering Manager to Sr. Engineering Manager (After 9 Years)</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Manage the team with high efficiency</li>
              <li>Oversee team functioning, manage employee 1:1 and ability to handle issues raised by the employee.</li>
              <li>Continuously thinking about team improvements and recommend suggestions to your manager.</li>
              <li>Work on feedback provided by employee and provide regular feedback to the employee.</li>
              <li>Identify critical metrics and build team indicators showing the operations of the team.</li>
              <li>Be part of annual performance review sessions and ensure conducting fair annual review process.</li>
              <li>Be a path finder for the team. Work on new scopes highly complex items and set up scope of work process flow for the team.</li>
              <li>Demonstrator of great values, innovator, receptive to fast changes and able to manage team in fast changing environments.</li>
              <li>Being involved in hiring process ensuring correct candidate fitting the team and meeting job requirement is hired.</li>
            </ul>
          </section>

          <section>
            <strong>4. Additional Guidelines</strong>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Years of service indicate minimum eligibility, not automatic promotion. Performance and competency are mandatory requirements.</li>
              <li>Even though highly rare, employees may be promoted earlier if they demonstrate exceptional skills, leadership, and impact. This is completely decision of your manager and management. No employee must make the request on their own.</li>
              <li>Training new folks, self-training and contribution to innovation increases promotion readiness.</li>
              <li>Leadership roles require demonstration of ownership, communication ability, and team support.</li>
              <li>Promotions are reviewed annually or as per business needs.</li>
            </ul>
          </section>




          <section>
            <strong>Competency Matrix by Role</strong>
            <p>
              The competency matrix defines the expected proficiency level for each role across key competency areas. Proficiency levels are defined as:
            </p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>L1 = Beginner (needs guidance)</li>
              <li>L2 = Intermediate (works independently on routine tasks)</li>
              <li>L3 = Advanced (handles complexity, mentors others)</li>
              <li>L4 = Expert (sets standards, leads strategy)</li>
              <li><strong>Note:</strong> L0 indicates not expected at that level.</li>
            </ul>


            <div style={{ textAlign: "center", margin: "20px 0" }}>
              <img
                src={competencyMatrixImg}
                alt="Competency Matrix Table"
                style={{ maxWidth: "100%", height: "auto", border: "1px solid #ccc", borderRadius: "8px" }}
              />
            </div>
          </section>


          <section>
            <strong>6. Competency Areas</strong>

            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>
                <strong>Engineering Designs:</strong> Discipline specific designs in accordance with the design and drafting standard.
              </li>
              <li>
                <strong>Data Validations:</strong> Effectively highlight gaps in the supplier data leading to non-designable content and delaying the start of the designs.
              </li>
              <li>
                <strong>Design & Drafting Standards:</strong> Understand and implement all code requirements and follow CAD drafting standards ensuring quality design packages.
              </li>
              <li>
                <strong>Documentation & QA/QC:</strong> Creating project drawings/documents and checking them for quality, accuracy, and mistakes.
              </li>
              <li>
                <strong>Coordination with other disciplines/Scopes:</strong> Working with all other teams or different scopes in the team to make sure we are following the standard and coordinating.
              </li>
              <li>
                <strong>Innovation and Automation:</strong> Ability to simplify process and execute quality work at fast pace by implementing automation.
              </li>
              <li>
                <strong>Communication & Stakeholder Management:</strong> Talking clearly with team members, clients, consultants, and managing their expectations professionally.
              </li>
              <li>
                <strong>Planning & Estimation:</strong> Manage all projects in assigned timeline ensuring proper work timelines to complete the assigned tasks.
              </li>
              <li>
                <strong>Leadership & Mentoring:</strong> Guiding team members, helping them learn, assigning tasks, and supporting teamwork.
              </li>
              <li>
                <strong>Process Improvement & Innovation:</strong> Finding better, faster ways to do work, improving workflows, introducing new ideas or tools.
              </li>
            </ul>
          </section>

        </div>
      )
    },
    {
      id: 2,
      title: "BIM MODELING",
      icon: "🏗️",
      content: (
        <div className="policy-details-text">
          <h2>BIM Team Growth Metrics & Role Progression Framework</h2>

          <p>
            This document presents a detailed and structured BIM Career Progression Framework aimed at enabling clarity, motivation, and long-term growth for every team member. The progression is based on a blend of years of service, technical competency, leadership skills, performance excellence, and contributions to project success. The purpose of this framework is to empower every BIM professional with a clear understanding of expectations, development pathways, and opportunities available within the organization.
          </p>

          <section>
            <strong>1. Role Progression Overview</strong>
            <p>The table below defines eligibility for roles based on minimum years of service, standard expectations, and capability demonstration:</p>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
              <thead>
                <tr>
                  <th style={thStyle}>Eligible at Service Year</th>
                  <th style={thStyle}>Eligible Role</th>
                  <th style={thStyle}>Role Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={tdStyle}>0 Years</td>
                  <td style={tdStyle}>BIM Modeler</td>
                  <td style={tdStyle}>Entry-level role focused on model creation, documentation, and learning BIM standards.</td>
                </tr>
                <tr>
                  <td style={tdStyle}>2 Years</td>
                  <td style={tdStyle}>Senior BIM Modeler</td>
                  <td style={tdStyle}>Advanced modeling responsibilities, quality checks, and mentoring junior modelers.</td>
                </tr>
                <tr>
                  <td style={tdStyle}>2 Years</td>
                  <td style={tdStyle}>BIM Lead (Eligibility)</td>
                  <td style={tdStyle}>Acts as the go-to technical expert Eligible for technical leadership roles based on performance and expertise.</td>
                </tr>
                <tr>
                  <td style={tdStyle}>4 Years</td>
                  <td style={tdStyle}>BIM Coordinator / BIM Engineer</td>
                  <td style={tdStyle}>Manages model coordination, clash detection, workflow optimization, and works closely with project leads and engineering teams.</td>
                </tr>
                <tr>
                  <td style={tdStyle}>6 Years</td>
                  <td style={tdStyle}>BIM Manager</td>
                  <td style={tdStyle}>Oversee BIM processes, standards, team development, project strategy, and implementation. Enforces standards and ensures team development and drives innovation.</td>
                </tr>
                <tr>
                  <td style={tdStyle}>9 Years</td>
                  <td style={tdStyle}>Senior BIM Manager</td>
                  <td style={tdStyle}>Leads the BIM function across multiple projects or a region. They set standards, strategy, and quality, mentor BIM teams, and work with project leadership and clients to ensure BIM delivers time, cost, and quality outcomes.</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "30px", textAlign: "center" }}>
              <img
                src={require('../assets/careerpathways3.png')}
                alt="BIM Role Progression Chart"
                style={{ maxWidth: "80%", height: "460px", borderRadius: "8px" }}
              />
            </div>
          </section>

          <section>
            <strong>2. Growth Metrics & Expectations</strong>
            <p>Each step in the BIM career pathway requires meeting specific measurable expectations. These metrics ensure fairness, transparency, and accountability.</p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Technical mastery and continuous learning across BIM platforms (Revit, Navisworks, BIM 360, Dynamo, etc.).</li>
              <li>Ability to understand, follow, and implement internal BIM guidelines and standards.</li>
              <li>Quality and accuracy of models, drawings, and deliverables with minimal supervision.</li>
              <li>Proactive collaboration with team members, consultants, and clients.</li>
              <li>Problem-solving ability and willingness to explore optimization methods.</li>
              <li>Leadership qualities such as initiative, mentoring, and ownership of responsibilities.</li>
              <li>Adherence to deadlines and ability to work efficiently under pressure.</li>
              <li>Being flexible and able to learn and use new methods or standards when the company changes or upgrades its systems.</li>
            </ul>
          </section>

          <section>
            <strong>3. Promotion Eligibility Criteria</strong>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.8", marginBottom: "20px" }}>
              <li style={{ marginBottom: "10px" }}>
                BIM Modeler → Senior BIM Modeler (After 2 Years)
                <ol style={{ marginTop: "10px", paddingLeft: "20px", lineHeight: "1.6" }}>
                  <li>High proficiency in Revit, BIM360/ACC, Navisworks, and other BIM tools.</li>
                  <li>Consistently delivers high-quality models with minimal errors.</li>
                  <li>Shows initiative in supporting team tasks and improving workflows.</li>
                  <li>Good understanding of project requirements and scope.</li>
                  <li>Ability to mentor newly joined modelers and assist leads.</li>
                </ol>
              </li>

              <li style={{ marginBottom: "10px" }}>
                Senior BIM Modeler → BIM Coordinator / BIM Engineer (After 4 Years)
                <ol style={{ marginTop: "10px", paddingLeft: "20px", lineHeight: "1.6" }}>
                  <li>Leads discipline-level modeling tasks and ensures model integrity.</li>
                  <li>Efficiently handles clash detection workflows and resolves coordination issues.</li>
                  <li>Experience working with multi-disciplinary teams and understanding cross-discipline impacts.</li>
                  <li>Strong communication skills for issue tracking, reporting, and meetings.</li>
                  <li>Demonstrates readiness to take ownership of project coordination responsibilities.</li>
                </ol>
              </li>

              <li style={{ marginBottom: "10px" }}>
                BIM Coordinator / BIM Engineer → BIM Manager (After 6 Years)
                <ol style={{ marginTop: "10px", paddingLeft: "20px", lineHeight: "1.6" }}>
                  <li>Leads entire BIM strategy and project delivery from a management standpoint.</li>
                  <li>Experience in creating BIM Execution Plans, workflows, and enforcing standards.</li>
                  <li>Capable of managing multiple teams.</li>
                  <li>Capable of managing multiple projects or disciplines simultaneously.</li>
                  <li>Provides training, guidance, and strategic direction for the BIM team.</li>
                  <li>Drives automation, innovation, and digital adoption across processes.</li>
                </ol>
              </li>
            </ul>
          </section>

          <section>
            <strong>4. Additional Guidelines</strong>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Years of service indicate minimum eligibility, not automatic promotion. Performance and competency are mandatory requirements.</li>
              <li>Employees may be promoted earlier if they demonstrate exceptional skills, leadership, and impact.</li>
              <li>Training new folks, self-training and contribution to innovation increase promotion readiness.</li>
              <li>Leadership roles (such as BIM Lead) require demonstration of ownership, communication ability, and team support.</li>
              <li>Promotions are reviewed annually or as per business needs.</li>
            </ul>
          </section>

          <section>
            <strong>5. Competency Matrix by Role</strong>
            <p>The competency matrix defines the expected proficiency level for each role across key competency areas. Proficiency levels are defined as:</p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>L1 = Beginner (needs guidance)</li>
              <li>L2 = Intermediate (works independently on routine tasks)</li>
              <li>L3 = Advanced (handles complexity, mentors others)</li>
              <li>L4 = Expert (sets standards, leads strategy)</li>

              <li> Note : L0 indicates not expected at that level.</li>
            </ul>

          </section>


          <div style={{ textAlign: "center", margin: "20px 0" }}>
            <img
              src={require('../assets/careerpathways4.png')}
              alt="Competency Matrix Visual Aid"
              style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", border: "1px solid #ccc" }}
            />
          </div>

          <li>
            <strong>1. Revit Modelling & Families:</strong> Making building models in Revit and creating basic components like doors, windows, furniture, etc.
          </li>
          <li>
            <strong>2. Navisworks / Clash Detection:</strong> Using Navisworks to combine all discipline models (Arch/Str/MEP) and find clashes (where elements collide) before project delivery.
          </li>
          <li>
            <strong>3. BIM Standards:</strong> Following the rules and guidelines for how BIM models, files, naming, and workflows should be created and managed in a project.
          </li>
          <li>
            <strong>4. Documentation & QA/QC:</strong> Creating project drawings/documents and checking them for quality, accuracy, and mistakes.
          </li>
          <li>
            <strong>5. Coordination with Other Disciplines:</strong> Working with all other teams or different scope in the team to make sure we are following the standard and coordinating.
          </li>
          <li>
            <strong>6. Automation (Dynamo / Scripts):</strong> Using tools like Dynamo or scripts to automate repetitive tasks in Revit or other BIM tools to save time.
          </li>
          <li>
            <strong>7. CDE Platforms (BIM 360 / ACC):</strong> Using cloud platforms like BIM 360 or ACC to store, manage, track, and share project files so everyone works with the latest information.
          </li>
          <li>
            <strong>8. Communication & Stakeholder Handling:</strong> Talking clearly with team members, clients, consultants, and managing their expectations professionally.
          </li>
          <li>
            <strong>9. Planning & Estimation (LOD, timelines):</strong> Understanding Level of Development (LOD) and planning how detailed the model should be and how long tasks will take.
          </li>
          <li>
            <strong>10. Leadership & Mentoring:</strong> Guiding team members, helping them learn, assigning tasks, and supporting teamwork.
          </li>
          <li>
            <strong>11. Process Improvement & Innovation:</strong> Finding better, faster ways to do work, improving workflows, introducing new ideas or tools.
          </li>


        </div>
      )
    },

    {
      id: 3,
      title: "POWER BI",
      icon: "📈",
      content: (
        <div className="policy-details-text">

          <h2>Technical Project Coordinator (Power BI)</h2>

          <p><strong>Team Growth Metrics & Role Progression Framework</strong></p>

          <p>
            This document outlines a structured career progression pathway for Technical Project Coordinators specializing in Power BI and data analytics solutions. The objective is to provide transparency in career development, motivate continuous learning, and define clear expectations for team members as they grow within the organization.
          </p>

          <p>
            The progression is based on a combination of technical expertise, analytical thinking, project coordination capability, business understanding, leadership qualities, and performance excellence.
          </p>

          <p>This framework helps every team member understand:</p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
            <li>What skills they must develop</li>
            <li>What responsibilities they must demonstrate</li>
            <li>How they can grow long-term within the organization</li>
          </ul>

          <section>
            <strong>1. Role Progression Overview</strong>

            <p>The table below defines eligibility for roles based on minimum years of service, standard expectations, and capability demonstration:</p>

            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
              <thead>
                <tr>
                  <th style={thStyle}>Eligible at Service Year</th>
                  <th style={thStyle}>Eligible Role</th>
                  <th style={thStyle}>Role Description</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style={tdStyle}>0 Years</td>
                  <td style={tdStyle}>Power BI Analyst / Junior Technical Coordinator</td>
                  <td style={tdStyle}>Entry-level role focused on building dashboards, cleaning data, assisting with reporting tasks, and learning internal data standards and tools.</td>
                </tr>

                <tr>
                  <td style={tdStyle}>2 Years</td>
                  <td style={tdStyle}>Senior Power BI Analyst</td>
                  <td style={tdStyle}>Responsible for advanced dashboard creation, data modelling, performance optimization, and assisting in data-driven decision making.</td>
                </tr>

                <tr>
                  <td style={tdStyle}>3 Years</td>
                  <td style={tdStyle}>Technical Project Coordinator (Power BI)</td>
                  <td style={tdStyle}>Coordinates reporting requirements with stakeholders, manages reporting timelines, ensures data accuracy, and leads dashboard delivery for projects.</td>
                </tr>

                <tr>
                  <td style={tdStyle}>5 Years</td>
                  <td style={tdStyle}>Data Analytics Lead / BI Lead</td>
                  <td style={tdStyle}>Leads analytics initiatives, manages reporting strategy, mentors analysts, and ensures dashboards align with business goals.</td>
                </tr>

                <tr>
                  <td style={tdStyle}>7 Years</td>
                  <td style={tdStyle}>Analytics Manager / BI Manager</td>
                  <td style={tdStyle}>Oversees BI architecture, reporting standards, team growth, analytics strategy, and cross-department data initiatives.</td>
                </tr>

                <tr>
                  <td style={tdStyle}>10 Years</td>
                  <td style={tdStyle}>Head of Business Intelligence / Data Strategy Lead</td>
                  <td style={tdStyle}>Drives enterprise analytics strategy, governs data standards, collaborates with leadership, and enables data-driven culture across the organization.</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "30px", textAlign: "center" }}>
              <img
                src={require('../assets/careerpathways5.png')}
                alt="Power BI Role Progression Chart"
                style={{ maxWidth: "80%", height: "460px", borderRadius: "8px" }}
              />
            </div>

          </section>

          <section>
            <strong>2. Growth Metrics & Expectations</strong>

            <p>Progression in the analytics team requires measurable contributions across the following areas:</p>

            <p><strong>Technical Capability</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Strong knowledge of Power BI, DAX, Power Query, and data modelling</li>
              <li>Understanding of SQL, databases, and data structures</li>
              <li>Ability to create efficient, scalable dashboards and reports</li>
              <li>Knowledge of data cleaning, transformation, and automation</li>
            </ul>

            <p><strong>Business Understanding</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Ability to translate business problems into data solutions</li>
              <li>Understanding of KPIs, business metrics, and reporting needs</li>
            </ul>

            <p><strong>Project Coordination</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Managing reporting timelines</li>
              <li>Ensuring stakeholders receive accurate and timely data</li>
              <li>Coordinating with multiple departments</li>
            </ul>

            <p><strong>Communication</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Clear communication of insights</li>
              <li>Ability to present dashboards and explain findings</li>
            </ul>

            <p><strong>Data Quality & Governance</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Maintaining data accuracy</li>
              <li>Ensuring reporting standards and governance practices</li>
            </ul>

            <p><strong>Innovation & Automation</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Automating repetitive reporting tasks</li>
              <li>Improving workflows through scripts or tools</li>
            </ul>

            <p><strong>Leadership & Mentorship</strong></p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Helping junior team members</li>
              <li>Guiding best practices</li>
              <li>Supporting team collaboration</li>
            </ul>
          </section>

          <section>
            <strong>4. Additional Guidelines</strong>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>Years of service indicate minimum eligibility, not automatic promotion.</li>
              <li>Promotions depend on performance, leadership, and impact.</li>
              <li>Employees showing exceptional capability may be promoted earlier.</li>
              <li>Contributing to automation, documentation, and innovation accelerates growth.</li>
              <li>Promotion reviews occur annually or based on business requirements.</li>
            </ul>
          </section>

          <section>
            <strong>5. Competency Matrix by Role</strong>

            <p>The competency matrix defines the expected proficiency level for each role across key competency areas. Proficiency levels are defined as:</p>

            <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
              <li>L1 = Beginner (needs guidance)</li>
              <li>L2 = Intermediate (works independently on routine tasks)</li>
              <li>L3 = Advanced (handles complexity, mentors others)</li>
              <li>L4 = Expert (sets standards, leads strategy)</li>
              <li> Note : L0 indicates not expected at that level.</li>
            </ul>

            {/* <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={require('../assets/careerpathways4.png')}
            alt="Competency Matrix Visual Aid"
            style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", border: "1px solid #ccc" }}
          />
        </div> */}

            <li><strong>1. Power BI Dashboard Development:</strong> Creating dashboards, reports, and visualizations to present data insights clearly.</li>
            <li><strong>2. Data Modelling:</strong> Designing relationships between tables and structuring datasets efficiently.</li>
            <li><strong>3. DAX Calculations:</strong> Creating advanced calculations and performance-optimized measures.</li>
            <li><strong>4. Data Transformation (Power Query):</strong> Cleaning, transforming, and preparing data from multiple sources.</li>
            <li><strong>5. SQL & Data Sources:</strong> Working with databases and integrating multiple data sources.</li>
            <li><strong>6. Data Governance & Documentation:</strong> Maintaining documentation, version control, and reporting standards.</li>
            <li><strong>7. Stakeholder Requirement Gathering:</strong> Understanding business needs and translating them into dashboards.</li>
            <li><strong>8. Insight Generation & Storytelling:</strong> Communicating insights clearly to decision makers.</li>
            <li><strong>9. Automation & Workflow Optimization:</strong> Using scripts, APIs, or automated refresh workflows.</li>
            <li><strong>10. Project Coordination:</strong> Managing reporting timelines, deliverables, and stakeholder expectations.</li>
            <li><strong>11. Leadership & Mentorship:</strong> Supporting team members, assigning work, and improving collaboration.</li>
            <li><strong>12. Analytics Strategy & Innovation:</strong> Developing new analytics solutions and improving business intelligence processes.</li>

          </section>

        </div>
      )
    }

  ];

  const pathways = isGenesis
    ? genesisPathways
    : dynamicPathways.map(item => ({
      id: item.id,
      title: item.pathway_title,
      icon: item.pathway_icon,
      content: (
        <div
          style={{
            whiteSpace: "pre-wrap",
            lineHeight: "1.9"
          }}
          dangerouslySetInnerHTML={{
            __html: item.pathway_content
              .replace(/\n/g, "<br>")
          }}
        />
      )
    }));

 
   return (
  <div className="policy-wrapper">

    {/* DESKTOP */}
    <div className="desktop-career-layout">

      <div className="policy-sidebar-nav glass">
        <div className="sidebar-header"></div>
        <div className="policy-menu">
          {pathways.map((p) => (
            <div
              key={p.id}
              className={`policy-item ${selectedPolicy?.id === p.id ? 'active' : ''}`}
              onClick={() => setSelectedPolicy(p)}
            >
              <div className="active-indicator"></div>
              <span className="p-icon">{p.icon}</span>
              <span className="p-text">{p.title}</span>
              {isRead(p.title) && <span className="p-status-check">✅</span>}
            </div>
          ))}
        </div>
      </div>

      <div className="policy-viewer glass">
        {selectedPolicy ? (
          <div className="viewer-content animate-fade">
            <div className="viewer-header">
              <div className="header-info">
                <h1>{selectedPolicy.title}</h1>
              </div>
            </div>

            <div className="cyber-divider"></div>

            <div className="document-body">
              <section className="doc-section">
                {selectedPolicy.content}
              </section>

              <div className="acknowledgement-section" style={{ marginTop: '40px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px', textAlign: 'center' }}>
                {/* acknowledgement button remains commented */}
              </div>
            </div>

            <div className="policy-footer">
              <p>
                © {isGenesis
                  ? "Genesis Tech Engineers Pvt. Ltd."
                  : "Career Pathways"}
              </p>
            </div>
          </div>
        ) : (
          <div style={{ position: "relative", width: "100%", height: "100%" }}>
            <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center" }}>
              <img
                src={
                  isGenesis
                    ? logoWhite
                    : (
                      companyLogo ||
                      logoWhite
                    )
                }
                alt="Company Logo"
                style={{
                  width: "350px",
                  height: "auto",
                  marginBottom: "80px"
                }}
              />

              <p
                style={{
                  fontSize: "25px",
                  opacity: "0.8",
                  whiteSpace: "nowrap"
                }}
              >
                PICK FROM THE SIDEBAR TO READ IT.
              </p>
            </div>
          </div>
        )}
            </div>

    </div>

    {/* MOBILE */}
    {!selectedPolicy ? (

      <div className="mobile-career-list">

        {pathways.map((p) => (

          <div
            key={p.id}
            className="mobile-career-card"
            onClick={() => setSelectedPolicy(p)}
          >

            <span className="mobile-career-icon">
              {p.icon}
            </span>

            <span className="mobile-career-title">
              {p.title}
            </span>

          </div>

        ))}

      </div>

    ) : (

      <div className="mobile-career-viewer">

        <button
          className="mobile-career-back"
          onClick={() => setSelectedPolicy(null)}
        >
          ← Back
        </button>

        <div className="viewer-content animate-fade">

          <div className="viewer-header">
            <div className="header-info">
              <h1>{selectedPolicy.title}</h1>
            </div>
          </div>

          <div className="cyber-divider"></div>

          <div className="document-body">
            <section className="doc-section">
              {selectedPolicy.content}
            </section>
          </div>

        </div>

      </div>

    )}

  </div>
);
};

export default CompanyPolicy;



